/**
 * Returns true if current time is within the restricted window (start → end)
 * Handles overnight ranges e.g. 22:00 → 06:00
 */
export const isWithinClosingTime = (startTime, endTime) => {
  if (!startTime || !endTime) return false;

  const now = new Date();
  const currentMinutes = now.getHours() * 60 + now.getMinutes();

  const toMinutes = (timeStr) => {
    const [h, m] = timeStr.split(":").map(Number);
    return h * 60 + m;
  };

  const start = toMinutes(startTime);
  const end   = toMinutes(endTime);

  if (start < end) {
    // Normal range e.g. 00:00 → 08:00
    return currentMinutes >= start && currentMinutes < end;
  } else {
    // Overnight range e.g. 22:00 → 06:00
    return currentMinutes >= start || currentMinutes < end;
  }
};

/**
 * Returns closing time config from localStorage init data
 * Returns null if feature is disabled or data is missing
 */
export const getClosingTimeConfig = (type) => {
  try {
    const rawData = localStorage.getItem('init');
    if (!rawData) return null;

    const parsedData = JSON.parse(rawData);
    const tc = parsedData?.[type];

    if (!tc?.feature) return null;  // feature disabled

    return {
      startTime: tc.starttime,
      endTime:   tc.endtime,
    };
  } catch {
    return null;
  }
};

/**
 * Single convenience check — use this in components
 * Returns true if clicking should be BLOCKED
 */
export const isClickBlocked = ( type = "tc" ) => {
  const config = getClosingTimeConfig(type);
  if (!config) return false;
  return isWithinClosingTime(config.startTime, config.endTime);
};


const generateTimeSlots = (hourStartIndex = 0, hourEndIndex = 24) => {
  const slots = [];
  for (let h = hourStartIndex; h < hourEndIndex; h++) {
    for (let m = 0; m < 60; m += 60) {
      const hh  = String(h).padStart(2, "0");
      const mm  = String(m).padStart(2, "0");
      const val = `${hh}:${mm}`;  // "08:00" — matches what API stores

      const period = h < 12 ? "AM" : "PM";
      const hour12 = h % 12 === 0 ? 12 : h % 12;
      const label  = `${hour12}:${mm} ${period}`;  // "8:00 AM"

      slots.push({ id: val, name: label });
    }
  }
  if(hourEndIndex === 24){
      slots.push({ id: "23:59", name: "11:59 PM" });
  }
  return slots;
};

export const StimingData = generateTimeSlots(0 , 12);
export const EtimingData = generateTimeSlots(12, 24);
